<template>
  <div class="contactus">
    <div class="pic" id="bg">
      <img
        src="/static/img/contact_tw_new.jpeg"
        width="100%"
        alt="联系鲨湾科技"
      />
      <!-- <div class="loc" @click="Tobaidumap"></div> -->
      <div class="info">
        <div class="infotitle">Blueshark Asia</div>
        <div class="content">地址：台北市內湖區洲子街181號2樓</div>
        <div class="content">電話：0800-777-707</div>
        <div class="content">信箱：marketing@sharkgulf.com</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    let that = this
    window.scrollTo(0, 0)
    this.$nextTick(function() {
      window.addEventListener('scroll', that.animateTxt)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  methods: {
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
    }
    // Tobaidumap() {
    //   window.open(
    //     'https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%97%B5%E8%A1%8C%E5%8C%BA%E5%AE%9C%E5%B1%B1%E8%B7%AF1698%E5%8F%B7%E5%85%B4%E8%BF%AA%E5%95%86%E5%8A%A1%E5%A4%A7%E5%8E%A6/@13513925.41415,3633117.008025,19z?querytype=con&wd=%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%97%B5%E8%A1%8C%E5%8C%BA%E5%AE%9C%E5%B1%B1%E8%B7%AF1698%E5%8F%B7%E5%85%B4%E8%BF%AA%E5%95%86%E5%8A%A1%E5%A4%A7%E5%8E%A6&c=289&provider=pc-aladin&pn=0&device_ratio=1&da_src=shareurl'
    //   )
    // }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/common.less';
.contactus {
  min-height: calc(100vh - 80px);
  background-color: #000;
  .pic {
    font-size: 0;
    position: relative;
    overflow: hidden;
    .loc {
      position: absolute;
      width: 60px;
      height: 80px;
      left: 38vw;
      top: 23.3vw;
      z-index: 1;
      cursor: pointer;
    }
    .info {
      position: absolute;
      background-color: #fff;
      padding: 60px 40px;
      bottom: 10vw;
      width: 300px;
      left: 10vw;
      .infotitle {
        color: @colorblue;
        font-size: 24px;
        margin-bottom: 30px;
      }
      .content {
        font-size: 14px;
        color: #666;
        text-indent: -40px;
        padding-left: 40px;
        line-height: 20px;
        margin-bottom: 10px;
      }
    }
  }
  .footer {
    line-height: 50px;
    height: 60px;
    background-color: #000;
    color: #fff;
    text-align: center;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tw/contactus.vue